import { gql } from "@apollo/client";

export const USER_POOL_GET_FAVOURITES_DATA = gql`
  query GetFavouritesData {
    userOfferIds: getUserOffers {
      id
    }
  }
`;
